// Ниши › Основни — the words a dossier uses and whether the niche runs at all.

import type { SetVerticalField, VerticalPatch } from './useVerticals.js';
import { TextField, ToggleField } from './fields.js';

export function VerticalBasicsTab({ draft, set }: { draft: VerticalPatch; set: SetVerticalField }) {
  return (
    <div className="adm__form">
      <TextField label="Име (бг)" value={draft.name_bg} onChange={(v) => set('name_bg', v)} />
      <TextField
        label="Име (en)"
        value={draft.name_en}
        onChange={(v) => set('name_en', v)}
        hint="Ползва се за английските заявки („{name} in Burgas“), когато английският е включен."
      />
      <TextField
        label="Как наричаме клиентите"
        value={draft.audience_noun_bg}
        onChange={(v) => set('audience_noun_bg', v)}
        hint="„пациенти“, „гости“, „собственици“ — влиза в досието и в текстовете на одита."
        placeholder="клиенти"
      />
      <TextField
        label="Стил на обръщение"
        value={draft.pitch_style_bg ?? ''}
        onChange={(v) => set('pitch_style_bg', v === '' ? null : v)}
        hint="Една изречение за тона на текстовете към този вид бизнес."
      />
      <ToggleField
        label="Активна ниша"
        checked={draft.active}
        onChange={(v) => set('active', v)}
        hint="Само активните ниши се откриват и одитират нощем. Шаблоните стоят изключени, докато не минат през „Нова ниша“."
      />
    </div>
  );
}
